import { PageRegisterAdvisorView } from './page-register-advisor.view'

function PageRegisterAdvisor() {
  return (
    <PageRegisterAdvisorView/>
  )
}

export { PageRegisterAdvisor }
